import React from "react";
import Page, { PageProps } from "../Page";
import { IFormTypesGroupCategoriesPresenter } from "../../../presenter/formconfiguration/FormTypesGroupCategoriesPresenter";
import { Form } from "antd";
import DataGrid from "../../components/app/grid/DataGrid";
import CreateFormTypesGroupCategoryForm, {
  CreateFormTypesGroupCategoryFormProps
} from "./CreateFormTypesGroupCategoryForm";
import UpdateFormTypesGroupCategoryForm, {
  UpdateFormTypesGroupCategoryFormProps
} from "./UpdateFormTypesGroupCategoryForm";
import FormTypesGroupCategoryExpanded from "./FormTypesGroupCategoryExpanded";
import TickBox from "../../components/app/grid/TickBox";
import Loader from "../../components/Loader";
export interface Props extends PageProps {}
export interface State extends IFormTypesGroupCategoriesPresenter {}

export default class FormTypesGroupCategoriesPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe(result => {
      return this.setState(prevState => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let {
      translate,
      formTypesGroupCategories,
      formTypes,
      assignedFormTypesCodes,
      spinnerEnabled
    } = this.state;

    const CreateForm = Form.create<CreateFormTypesGroupCategoryFormProps>({})(
      CreateFormTypesGroupCategoryForm
    );

    const UpdateForm = Form.create<UpdateFormTypesGroupCategoryFormProps>({})(
      UpdateFormTypesGroupCategoryForm
    );

    const columns = [
      {
        title: translate("form_types_group_category_form.code"),
        dataIndex: "code",
        key: "code"
      },
      {
        title: translate("form_types_group_category_form.name"),
        dataIndex: "name",
        key: "name"
      },
      {
        title: translate("form_types_group_category_form.valid"),
        dataIndex: "valid",
        key: "valid",
        render: (text, record) => <TickBox value={record.valid} />,
        width: "5%"
      }
    ];

    const expandedRowRender = e => {
      return (
        <FormTypesGroupCategoryExpanded
          translate={translate}
          formTypes={formTypes}
          assignedFormTypesCodes={assignedFormTypesCodes}
          spinnerEnabled={spinnerEnabled}
          onFormTypesChange={this.state.onFormTypeSelectChange}
        />
      );
    };

    const dataGrid = (
      <DataGrid
        title={translate("grids.form-types-group-categories")}
        translate={translate}
        columns={columns}
        dataSource={formTypesGroupCategories}
        allowCreate={true}
        allowDelete={false}
        allowUpdate={true}
        createForm={CreateForm}
        createModalTitle={translate(
          "form_types_group_category_form.insert_modal_title"
        )}
        onCreate={this.state.createFormTypesGroupCategory}
        updateForm={UpdateForm}
        updateModalTitle={translate(
          "form_types_group_category_form.update_modal_title"
        )}
        onUpdate={this.state.updateFormTypesGroupCategory}
        singleRowExpandEnabled={true}
        expandedRowRender={expandedRowRender}
        onExpand={this.state.onRowExpanded}
        booleanColumnKeys={["valid"]}
        addButtonText={translate(
          "form_types_group_category_form.add_button_text"
        )}
      />
    );

    return (
      <Page {...this.props}>
        <Loader
          children={dataGrid}
          translate={translate}
          loading={this.state.loaders.formTypesGroupLoader}
        />
      </Page>
    );
  }
}
